const $ = require("jquery");

import { createElement } from "react";
import { render } from "react-dom";
import EducationFiltererMbo from "../components/EducationFiltererMbo.jsx";
import { updateContent } from "../global/update-content.js";

$(document).ready(function() {
  renderWithProps(EducationFiltererMbo, $("#education-filterer-root"));
  renderWithProps(EducationFiltererMbo, $(".education-filterer-root"));

  $(".filter__reset").each(function() {
    if ($(this).siblings(".filter__select--active").length == 0) {
      $(this).hide();
    }
  });

  $(".filter__reset").on("click", function(e) {
    e.preventDefault();
    $(this)
      .siblings(".filter__select")
      .val("0")
      .trigger("change");
    $(this)
      .siblings(".filter__select")
      .removeClass("filter__select--active");
    $(this)
      .css("display", "none")
      .hide(".filter__reset");

    // When used on an archive set name value to '' to disable filtering
    if (
      $("body").hasClass("page-template-educations-mbo") ||
      $("body").hasClass("post-type-archive")
    ) {
      const name = $(this)
        .siblings(".filter__select")
        .attr("name");
      const val = "";
      updateContent(name, val);
    }
  });

  /**
   * Triggers upon filter change and search education in the backend
   */
  $(".filter .filter__select").on("change", function() {
    if ($(this).parents(".education-filterer-root").length > 0) {
      return;
    }

    $(this)
      .siblings(".filter__reset")
      .show();
    $(this).addClass("filter__select--active");

    let params = {};
    $(".filter .filter__select").each(function() {
      let name = $(this)
        .attr("name")
        .replace("filter_", "");
      params[name] = $(this).val();
    });

    $.ajax({
      url: "/wp-admin/admin-ajax.php?action=filter_education",
      data: params,
      dataType: "json",
      success: function(response) {
        var uniqueOpleidingen = new Set(
          response.map(
            item =>
              item.opleiding + "_" + item.niveau + "_" + item.opleidingsrichting
          )
        );
        $(".filter .filter__close").text(
          "Bekijk " + uniqueOpleidingen.size + " opleidingen"
        );
      }
    });
  });
});

function renderWithProps(component, $el) {
  if ($el.length !== 0) {
    render(createElement(component, $el.data()), $el[0]);
  }
}
